import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Lookup from '../../entities/lookup';
import Blackout from '../../entities/blackout';
import Discount from '../../entities/discount';
import Document from '../../entities/document';
import Expense from '../../entities/expense';
import Event from '../../entities/event';
import Identification from '../../entities/identification';
import Milestone from '../../entities/milestone';
import Participant from '../../entities/participant';
import TimeOff from '../../entities/timeOff';

/*
 * Delete/nullify anywhere this lookup is used in other entities
 *
 * @param {Lookup} lookup
 */
export function deleteLookup(lookup: Lookup, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = lookup.id;
    }
    /* Simple delete usages */
        
    store.getState().blackouts
        .getMappingFor('lookupId', lookup.id)
        .filter(blackoutTemp => blackoutTemp.status !== 'D')
        .forEach(blackoutTemp => {
            const _blackout = blackoutTemp.clone();
            _blackout.status =  'U';
            _blackout.addedOn = newHRTimestamp();
            _blackout.addedBy = getCurrentUserId();
            _blackout.importSource = targetImportSource;
            _blackout.importId = mergeId;

            _blackout.reason = '';
            store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
        });

    store.getState().discounts
        .getMappingFor('lookupId', lookup.id)
        .filter(discountTemp => discountTemp.status !== 'D')
        .forEach(discountTemp => {
            const _discount = discountTemp.clone();
            _discount.status =  'U';
            _discount.addedOn = newHRTimestamp();
            _discount.addedBy = getCurrentUserId();
            _discount.importSource = targetImportSource;
            _discount.importId = mergeId;

            _discount.reason = '';
            store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
        });

    store.getState().documents
        .getMappingFor('lookupId', lookup.id)
        .filter(documentTemp => documentTemp.status !== 'D')
        .forEach(documentTemp => {
            const _document = documentTemp.clone();
            _document.status =  'U';
            _document.addedOn = newHRTimestamp();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;

            _document.tags = _document.tags?.filter(id => id !== lookup.id) || [];
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
        });

    store.getState().expenses
        .getMappingFor('lookupId', lookup.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.expenseType = '';
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().events
        .getMappingFor('lookupId', lookup.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.category = '';
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    store.getState().identifications
        .getMappingFor('lookupId', lookup.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.methodType = '';
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    store.getState().milestones
        .getMappingFor('lookupId', lookup.id)
        .filter(milestoneTemp => milestoneTemp.status !== 'D')
        .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            _milestone.status =  'U';
            _milestone.addedOn = newHRTimestamp();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;

            _milestone.reasons = _milestone.reasons?.filter(id => id !== lookup.id) || [];
            store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
        });

    store.getState().participants
        .getMappingFor('lookupId', lookup.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.relationships = _participant.relationships?.filter(id => id !== lookup.id) || [];
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().timeOffs
        .getMappingFor('lookupId', lookup.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.reason = '';
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    /* Remove the actual lookup */
    lookup.status = 'D';
    lookup.addedOn = newHRTimestamp();
    lookup.addedBy = getCurrentUserId();
    lookup.importSource = targetImportSource;
    lookup.importId = mergeId;
    store.dispatch(Actions.LookupActions.removeLookupQueue(lookup));
    
}

/*
 * Replace anywhere this lookup is used in other entities.
 *
 * @param {Lookup} lookup
 * @param {Lookup} replaceWith
 * @return {Lookup} - Lookup will have refs stripped away
 */
export function replaceLookup(lookup: Lookup, replaceWith: Lookup, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = lookup.id;
    }
    /* Simple replace usages */
        
    store.getState().blackouts
        .getMappingFor('lookupId', lookup.id)
        .filter(blackoutTemp => blackoutTemp.status !== 'D')
        .forEach(blackoutTemp => {
            const _blackout = blackoutTemp.clone();
            _blackout.status =  'U';
            _blackout.addedOn = newHRTimestamp();
            _blackout.addedBy = getCurrentUserId();
            _blackout.importSource = targetImportSource;
            _blackout.importId = mergeId;

            _blackout.reason = replaceWith.id;
            store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
        });

    store.getState().discounts
        .getMappingFor('lookupId', lookup.id)
        .filter(discountTemp => discountTemp.status !== 'D')
        .forEach(discountTemp => {
            const _discount = discountTemp.clone();
            _discount.status =  'U';
            _discount.addedOn = newHRTimestamp();
            _discount.addedBy = getCurrentUserId();
            _discount.importSource = targetImportSource;
            _discount.importId = mergeId;

            _discount.reason = replaceWith.id;
            store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
        });

    store.getState().documents
        .getMappingFor('lookupId', lookup.id)
        .filter(documentTemp => documentTemp.status !== 'D')
        .forEach(documentTemp => {
            const _document = documentTemp.clone();
            _document.status =  'U';
            _document.addedOn = newHRTimestamp();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;

            _document.tags = _document.tags?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
        });

    store.getState().expenses
        .getMappingFor('lookupId', lookup.id)
        .filter(expenseTemp => expenseTemp.status !== 'D')
        .forEach(expenseTemp => {
            const _expense = expenseTemp.clone();
            _expense.status =  'U';
            _expense.addedOn = newHRTimestamp();
            _expense.addedBy = getCurrentUserId();
            _expense.importSource = targetImportSource;
            _expense.importId = mergeId;

            _expense.expenseType = replaceWith.id;
            store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
        });

    store.getState().events
        .getMappingFor('lookupId', lookup.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.addedBy = getCurrentUserId();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.category = replaceWith.id;
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    store.getState().identifications
        .getMappingFor('lookupId', lookup.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.addedBy = getCurrentUserId();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.methodType = replaceWith.id;
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    store.getState().milestones
        .getMappingFor('lookupId', lookup.id)
        .filter(milestoneTemp => milestoneTemp.status !== 'D')
        .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            _milestone.status =  'U';
            _milestone.addedOn = newHRTimestamp();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;

            _milestone.reasons = _milestone.reasons?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
        });

    store.getState().participants
        .getMappingFor('lookupId', lookup.id)
        .filter(participantTemp => participantTemp.status !== 'D')
        .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            _participant.status =  'U';
            _participant.addedOn = newHRTimestamp();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;

            _participant.relationships = _participant.relationships?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
        });

    store.getState().timeOffs
        .getMappingFor('lookupId', lookup.id)
        .filter(timeOffTemp => timeOffTemp.status !== 'D')
        .forEach(timeOffTemp => {
            const _timeOff = timeOffTemp.clone();
            _timeOff.status =  'U';
            _timeOff.addedOn = newHRTimestamp();
            _timeOff.addedBy = getCurrentUserId();
            _timeOff.importSource = targetImportSource;
            _timeOff.importId = mergeId;

            _timeOff.reason = replaceWith.id;
            store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
        });

    return lookup;
}

/*
 * Determine the impact of deleting this lookup from other entities
 *
 * @param {Lookup} lookup
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactLookup(lookup: Lookup) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const blackoutReasonImpact = state.blackouts
          .getMappingFor('lookupId', lookup.id)
          .filter(blackout => blackout.status !== 'D');

    blackoutReasonImpact.forEach(() => impacts.push('blackouts*'));

    const discountReasonImpact = state.discounts
          .getMappingFor('lookupId', lookup.id)
          .filter(discount => discount.status !== 'D');

    discountReasonImpact.forEach(() => impacts.push('discounts*'));

    const documentTagsImpact = state.documents
          .getMappingFor('lookupId', lookup.id)
          .filter(document => document.status !== 'D');

    documentTagsImpact.forEach(() => impacts.push('documents'));

    const expenseExpenseTypeImpact = state.expenses
          .getMappingFor('lookupId', lookup.id)
          .filter(expense => expense.status !== 'D');

    expenseExpenseTypeImpact.forEach(() => impacts.push('expenses*'));

    const eventCategoryImpact = state.events
          .getMappingFor('lookupId', lookup.id)
          .filter(event => event.status !== 'D');

    eventCategoryImpact.forEach(() => impacts.push('events*'));

    const identificationMethodTypeImpact = state.identifications
          .getMappingFor('lookupId', lookup.id)
          .filter(identification => identification.status !== 'D');

    identificationMethodTypeImpact.forEach(() => impacts.push('identifications*'));

    const milestoneReasonsImpact = state.milestones
          .getMappingFor('lookupId', lookup.id)
          .filter(milestone => milestone.status !== 'D');

    milestoneReasonsImpact.forEach(() => impacts.push('milestones'));

    const participantRelationshipsImpact = state.participants
          .getMappingFor('lookupId', lookup.id)
          .filter(participant => participant.status !== 'D');

    participantRelationshipsImpact.forEach(() => impacts.push('participants*'));

    const timeOffReasonImpact = state.timeOffs
          .getMappingFor('lookupId', lookup.id)
          .filter(timeOff => timeOff.status !== 'D');

    timeOffReasonImpact.forEach(() => impacts.push('timeOffs*'));

    return util.countDistinct(impacts);
}